import Tooltip from '@mui/material/Tooltip';
import { formatCompactNumber } from '@openx/components-core/utils/formatCompactNumber';
import { bigNumberWithCommas } from '@openx/utils/lib/bigNumberWithCommas';

export function DisplayBigNumber({ number, compact = false }: { number: number; compact?: boolean }) {
  const numInt = parseInt(`${number}`, 10);

  if (compact) {
    return (
      <Tooltip title={bigNumberWithCommas(numInt)} aria-label={bigNumberWithCommas(numInt)}>
        <span>{formatCompactNumber(numInt)}</span>
      </Tooltip>
    );
  }

  return <span>{bigNumberWithCommas(numInt)}</span>;
}
